import React from 'react';
import { FeatureContainer, FeatureButton } from './FAQElements';

const Feature = () => {
  return (
    <FeatureContainer>
      <h1>FAQ</h1>
      <FeatureButton></FeatureButton>
      <p>How do I adopt a Crypto Bear?</p>
<h5>You can adopt a CryptoBear from either our website or opensea, minting process from the website is under progress though you can buy from opensea</h5>

<p>How do I join the community?</p>
<h5>Crypto Bears make great profile pictures so you can easily spot fellow community members! Follow the official Twitter account and come and say hi in the community Discord server.</h5>

<p>Are CryptoBearsClub supporting charities?</p>
<h5>Yes! CryptoBearsClub has committed to donating $10 for every sale made i.e., $10,000 in Total.

Join the Discord server to learn more about why we chose to support these wonderful charities and the crucial work they're doing.</h5>

<p>What are NFTs?</p>
<h5>NFTs are Non-Fungible Tokens. Each CryptoBear NFT that you own is truly unique and verifiable on the Polygon blockchain.</h5>

<p>Who are the Founders of CryptoBearsClub ?</p>
<h5>You can find more about the team on our socials</h5>

<p>What inspired CryptoBearsClub?</p>
<h5>CryptoBearsClub was created by a team of DeFi builders who've been learning and contributing to this space. We've been avid NFT collectors and blown away by the uniting power of the NFT communities we've been involved with.

We're committed to growing the CryptoBearsClub brand and providing long term value for our community.</h5>

<p>What can I do with my CryptoBear?</p>
<h5>You are free to do anything you want with them under a non-exclusive license.</h5>
    </FeatureContainer>
  );
};

export default Feature;
